jQuery(document).ready(function ($) {
	/**
	 * Code editors
	 */
	const $editors = $(".adcmdr-code-editor");

	const editorSettings =
		wp.codeEditor && wp.codeEditor.defaultSettings
			? _.clone(wp.codeEditor.defaultSettings)
			: {};

	editorSettings.codemirror = _.extend({}, editorSettings.codemirror, {
		lineNumbers: true,
		indentUnit: 4,
		tabSize: 4,
		// Add other CodeMirror settings here
	});

	if ($editors.length > 0) {
		$editors.each(function () {
			const $editor = $(this);

			// Initialize the editor on the textarea with the ID 'my-custom-textarea'
			const codeEditor = wp.codeEditor.initialize($editor, editorSettings);

			// If you need the content to be saved back to the original textarea on changes:
			$(document).on("keyup", ".CodeMirror-code", function () {
				codeEditor.codemirror.save();
				$editor.trigger("change");
			});
		});
	}
});
